import { useSearchParams } from "react-router-dom";
import { AiReadinessFramework } from "./AiReadinessFramework";
import { Checklist } from "./Checklist";
import { Playbook } from "./Playbook";
import { AiUsecase } from "./AiUsecase";
import { Statbook } from "./Statbook";
import { ExecutiveBrief } from "./ExecutiveBrief";
import { AiInFintech } from "./AiInFintech";
import { EBookList } from "./EBookList";
import { ReportList } from "./ReportList";

const ASSETS_TABS = [
  {
    tabIndex: 0,
    tabId: "ebook",
    tabName: "Ebook",
  },
  {
    tabIndex: 1,
    tabId: "framework",
    tabName: "Framework",
  },
  {
    tabIndex: 2,
    tabId: "playbook",
    tabName: "Playbook",
  },
  {
    tabIndex: 3,
    tabId: "checklist",
    tabName: "Checklist",
  },
  {
    tabIndex: 4,
    tabId: "use-cases",
    tabName: "Use Cases",
  },
  {
    tabIndex: 5,
    tabId: "statbook",
    tabName: "Statbook",
  },
  {
    tabIndex: 6,
    tabId: "eguide",
    tabName: "Eguide",
  },
  {
    tabIndex: 7,
    tabId: "executive-brief",
    tabName: "Executive Brief",
  },
  {
    tabIndex: 8,
    tabId: "report",
    tabName: "Report",
  },
];

const AssetsView: Record<number, JSX.Element> = {
  0: <EBookList />,
  1: <AiReadinessFramework />,
  2: <Playbook />,
  3: <Checklist />,
  4: <AiUsecase />,
  5: <Statbook />,
  6: <AiInFintech />,
  7: <ExecutiveBrief />,
  8: <ReportList />,
};

export const AssetsFramework = (): JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams({ tabIndex: "0" });

  const handleTabChange = (tabId: number) => {
    setSearchParams((params) => {
      params.set("tabIndex", JSON.stringify(tabId));
      return params;
    });
  };

  const tabIndex = searchParams.get("tabIndex");
  const parsedTabIndex = tabIndex ? JSON.parse(tabIndex) : 0;

  return (
    <>
      <div className="main-container podcasts">
        <div className="podcasts-tab">
          {ASSETS_TABS.map((tab) => {
            const { tabIndex, tabId, tabName } = tab;

            return (
              <div
                key={tabId}
                className={`item ${tabIndex === parsedTabIndex ? "active" : ""}`}
                onClick={() => handleTabChange(tabIndex)}
              >
                {tabName}
              </div>
            );
          })}
        </div>

        {AssetsView[parsedTabIndex]}
      </div>
    </>
  );
};
